module.exports = __webpack_public_path__ + "img/Apple-Pay-Logo-0٣.ea2a0a44.png";